import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'achoo-chip',
  templateUrl: './achoo-chip.component.html',
  styleUrls: ['./achoo-chip.component.scss']
})
export class AchooChipComponent {
  @Input()
  text: string;

  @Input()
  removable = false;

  @Input()
  material = false;

  @Input()
  isProcessing = false;

  @Input()
  isError = false;

  @Output()
  remove = new EventEmitter<any>();

  onClickRemove(event) {
    this.remove.emit(event);
  }
  isHashtag() {
    return this.text && this.text.charAt(0) === '#';
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-chip/achoo-chip.component.ts